export default __webpack_public_path__ + "images/0xaaaebe6fe48e54f431b0c390cfaf0b017d09d42d.png";